import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import { PAGES } from '../../constants/pages';
import {
  ACCOUNT_TYPE_UTMA_CUSTODIAN,
  ACCOUNT_TYPE_UTMA_TRUSTEE,
  APPLICATION_TYPE_UTMA,
} from '../../constants/accountTypes';

import SelectList from '../../components/SelectList/SelectList';
import useChooseApplication from '../../hooks/useChooseApplication';
import BaseLayout from '../../components/BaseLayout';
import { Heading } from '../../components/Heading';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import SaveAndCloseModal from '../../components/Modals/SaveAndCloseModal/SaveAndCloseModal';
import { gtmStepHelper } from '../../util/helpers/gtmHelper';
import useGtmStepHook from '../../util/hooks/useGtmStepHook';
import { retrieveFromSessionStorage } from '../../util/helpers/sessionStorageHelper';
import { ACCOUNT_TYPE_GTM } from '../../constants/sessionStorage';
import { ACCOUNT_STEP_COMPLETE, ACCOUNT_STEP_VIEW } from '../../util/gtmEvents';

const ChooseApplicationUtma = () => {
  const { t } = useTranslation();
  const { onSelectType } = useChooseApplication();
  const { BrokerName } = useSelector(selectSettings);
  const [eventType, setEventType] = useState('NoForm');
  const [saveAndCloseModalOpen, setSaveAndCloseModalOpen] = useState(false);
  const { gtmStepEvent } = useGtmStepHook();
  const accountGtmType = retrieveFromSessionStorage(ACCOUNT_TYPE_GTM);

  const gtmEvent = () => {
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_COMPLETE,
      stepLabel: 'Choose application UTMA',
      accountType: accountGtmType,
      customParams: {
        timestamp: new Date().toISOString(),
      },
    });
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_VIEW,
      stepLabel: 'Secure your account',
      accountType: accountGtmType,
      customParams: {
        timestamp: new Date().toISOString(),
      },
    });
  };

  const options = [
    {
      title: t('selectPath.options.utma.custodian'),
      onClick: () => {
        onSelectType({
          ApplicationType: APPLICATION_TYPE_UTMA,
          UTMAAccountType: ACCOUNT_TYPE_UTMA_CUSTODIAN,
        });
        gtmEvent();
      },
    },
    {
      title: t('selectPath.options.utma.trust'),
      onClick: () => {
        onSelectType({
          ApplicationType: APPLICATION_TYPE_UTMA,
          UTMAAccountType: ACCOUNT_TYPE_UTMA_TRUSTEE,
        });
        gtmEvent();
      },
      showDivider: false,
    },
  ];

  return (
    <BaseLayout
      canShowEmail={false}
      previousPath={PAGES.CHOOSE_APPLICATION.MAIN}
      setEventType={setEventType}
      eventType={eventType}
      setSaveAndCloseModalOpen={setSaveAndCloseModalOpen}
    >
      <Helmet>
        <title>
          {t('selectPath.options.utma.titleTag', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading mb={28}>{t('selectPath.options.utma.title')}</Heading>
      <SelectList options={options} />
      {saveAndCloseModalOpen && (
        <SaveAndCloseModal
          isOpen={saveAndCloseModalOpen}
          onClose={() => setSaveAndCloseModalOpen(false)}
        />
      )}
    </BaseLayout>
  );
};

export default ChooseApplicationUtma;
